import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/Stores/auth-v2-store';
import { authApi } from '@/Api/auth-v2.api';

export const useAuth = () => {
  const store = useAuthStore();
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!store.accessToken || !store.refreshToken) return;

    intervalRef.current = setInterval(async () => {
      try {
        const { accessToken } = await authApi.refreshToken(store.refreshToken!);
        store.setTokens(accessToken, store.refreshToken!);
      } catch (error) {
        console.error('Failed to refresh token:', error);
        store.logout();
      }
    }, 14 * 60 * 1000); // 14 minutes

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [store.accessToken, store.refreshToken]);

  return {
    user: store.currentUser,
    isAuthenticated: store.isAuthenticated,
    hasPermission: store.hasPermission,
    hasAnyPermission: store.hasAnyPermission,
    logout: store.logout,
  };
};
